const userHexColors = [
    '#e51c23',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#5677fc',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#259b24',
    '#8bc34a',
    '#afb42b',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#607d8b',
];

const getUserColor = (username?: string): string => {
    if (!username || username.length === 0) {
        return '#bdbdbd';
    }

    let hash = 0;
    for (let i = 0; i < username.length; i++) {
        hash = username.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    hash =
        ((hash % userHexColors.length) + userHexColors.length) %
        userHexColors.length;

    return userHexColors[hash];
};

export { getUserColor, userHexColors };
